"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegisterNurseAccountDto = instanceOfRegisterNurseAccountDto;
exports.RegisterNurseAccountDtoFromJSON = RegisterNurseAccountDtoFromJSON;
exports.RegisterNurseAccountDtoFromJSONTyped = RegisterNurseAccountDtoFromJSONTyped;
exports.RegisterNurseAccountDtoToJSON = RegisterNurseAccountDtoToJSON;
exports.RegisterNurseAccountDtoToJSONTyped = RegisterNurseAccountDtoToJSONTyped;
const AddressCreateDto_1 = require("./AddressCreateDto");
const PhoneNumberCreateDto_1 = require("./PhoneNumberCreateDto");
/**
 * Check if a given object implements the RegisterNurseAccountDto interface.
 */
function instanceOfRegisterNurseAccountDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('ssn' in value) || value['ssn'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    return true;
}
function RegisterNurseAccountDtoFromJSON(json) {
    return RegisterNurseAccountDtoFromJSONTyped(json, false);
}
function RegisterNurseAccountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : (new Date(json['dateOfBirth'])),
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : (0, PhoneNumberCreateDto_1.PhoneNumberCreateDtoFromJSON)(json['phoneNumber']),
        'ssn': json['ssn'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoFromJSON)(json['address']),
    };
}
function RegisterNurseAccountDtoToJSON(json) {
    return RegisterNurseAccountDtoToJSONTyped(json, false);
}
function RegisterNurseAccountDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': value['dateOfBirth'] == null ? undefined : (value['dateOfBirth'].toISOString().substring(0, 10)),
        'email': value['email'],
        'phoneNumber': (0, PhoneNumberCreateDto_1.PhoneNumberCreateDtoToJSON)(value['phoneNumber']),
        'ssn': value['ssn'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoToJSON)(value['address']),
    };
}
//# sourceMappingURL=RegisterNurseAccountDto.js.map